<template>
  <div class="emoji-container">
    <VEmojiPicker @select="selectEmoji"
                  :dark="true"
                  class="emoji-picker"
                  :style="{'--border-colour': spaceBackgroundColour}"
                  v-click-outside="closeEmojiPopup"
    />
  </div>
</template>
<script>
import { VEmojiPicker } from 'v-emoji-picker';
import { mapGetters } from 'vuex'

export default {
  name: 'ChatEmojiPicker',
  props: {
    closeEmojiPopup: Function,
    selectEmoji: Function
  },
  components: {
    VEmojiPicker
  },
  computed: {
    ...mapGetters({
      spaceBackgroundColour: 'getCurrentAreaPrimaryColour'
    })
  },
};
</script>

<style lang="scss">
@import '~@/scss/components/sidebar/chat_emoji_picker.scss';
</style>
